import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { Error } from './types'
import { EpisodeDetailsTimeline } from 'store/types'
import { EpisodeApi } from 'api/episode'
import { UserApi } from 'api/user'
import { setExpandedItemId, setLoadingItemId } from './slice'
import { AppRoutes } from 'router/routesConfig'
import history from 'utils/history'

export const getEpisodeDetails = createAsyncThunk<
  { episodeDetails: EpisodeDetailsTimeline[]; isCourseCompleted: boolean },
  string,
  { rejectValue: { message: string } }
>('item-details/getEpisodeDetails', async (seriesVersionId, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setLoadingItemId(seriesVersionId))
    const { episodeDetails, isCourseCompleted } = await EpisodeApi.getEpisodeDetailsRequest(
      seriesVersionId
    )
    dispatch(setExpandedItemId(seriesVersionId))
    return {
      episodeDetails,
      isCourseCompleted,
    }
  } catch (err) {
    const error = err as AxiosError
    if (error) {
      return rejectWithValue({ message: error.response?.data.Message })
    }
    throw err
  }
})

export const moveEpisodeToTheTopOfTimeline = createAsyncThunk<void, string, { rejectValue: Error }>(
  'item-details/moveEpisodeToTheTopOfTimeline',
  async (userEpisodeId, { rejectWithValue }) => {
    try {
      await UserApi.moveEpisodeToTheTopOfTimeline(userEpisodeId)
      history.push(AppRoutes.TIMELINE)
    } catch (err) {
      const error = err as AxiosError
      if (error) {
        return rejectWithValue({ message: error.response?.data.Message })
      }
      throw err
    }
  }
)

export const getCourseDetails = createAsyncThunk<
  {
    episodesDetails: EpisodeDetailsTimeline[]
    episodeDates: { name: string | null; start: string; end: string }[]
    availableFrom: string
  },
  string,
  { rejectValue: Error }
>('item-details/getCourseDetails', async (id, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setLoadingItemId(id))
    const courseDetails = await UserApi.getCourseDetailsRequest(id)
    dispatch(setExpandedItemId(id))

    return courseDetails
  } catch (err) {
    const error = err as AxiosError
    if (error) {
      return rejectWithValue({ message: error.response?.data.Message })
    }
    throw err
  }
})
